import { render, staticRenderFns } from "./AboutSwiper4.vue?vue&type=template&id=5d688188&scoped=true&"
import script from "./AboutSwiper4.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper4.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper4.vue?vue&type=style&index=0&id=5d688188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d688188",
  null
  
)

export default component.exports